import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from '../../../../theme/Color';
import style from '../CustomViewTask.module.css';

interface HeaderActionsProps {
  onEdit: (event: React.MouseEvent<HTMLDivElement>) => void;
  onDelete: (event: React.MouseEvent<HTMLDivElement>) => void;
  onClose: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const HeaderActions: React.FC<HeaderActionsProps> = ({ onEdit, onDelete, onClose }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: { xs: '30px 20px 20px 20px', xl: '40px 24px 24px 24px' },
      }}
    >
      <Typography variant='responsiveHeading2' color={zeplinColor.BasicBlack}>
        Task Details
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: { xs: '10px', xl: '16px' },
          alignItems: 'center',
        }}
      >
        <img
          src={'/assets/edit.svg'}
          className={style['icon']}
          alt='edit'
          style={{ cursor: 'pointer' }}
          onClick={onEdit}
        />
        <img
          src={'/assets/delete.svg'}
          className={style['icon']}
          alt='delete'
          style={{ cursor: 'pointer' }}
          onClick={onDelete}
        />
        <Divider
          orientation='vertical'
          flexItem
          sx={{
            borderColor: zeplinColor.Neutral5,
            height: '24px',
            margin: '0 4px',
          }}
        />
        <img
          src={'/assets/close-icon.svg'}
          className={style['icon']}
          alt='close'
          style={{ cursor: 'pointer' }}
          onClick={onClose}
        />
      </Box>
    </Box>
  );
};
